import { useEffect, useState } from "react";
import { ShieldCheck, CalendarCheck, Star, MapPin } from "lucide-react";
import { api } from "../../lib/api";

const BASE = [
  { icon: CalendarCheck, text: "Building roofs since 2010" },
  { icon: ShieldCheck, text: "Licensed & fully insured" },
  { icon: MapPin, text: "All of Perth · within 20 km of South Perth" },
  { icon: ShieldCheck, text: "Residential & commercial" },
];

export function TrustBar() {
  const [rating, setRating] = useState(null);

  useEffect(() => {
    api.get("/reviews").then((r) => {
      if (r.data?.enabled && r.data.rating) setRating({ rating: r.data.rating, total: r.data.total, url: r.data.place_url });
    }).catch(() => {});
  }, []);

  const items = rating
    ? [BASE[0], BASE[1], { icon: Star, text: `${rating.rating} ★ · ${rating.total} Google reviews` }, BASE[2], BASE[3]]
    : BASE;
  const row = [...items, ...items, ...items];

  return (
    <div data-testid="trust-bar" className="bg-[#224733] text-white py-3.5 overflow-hidden border-y border-white/5">
      <div className="flex w-max wf-marquee">
        {row.map((it, i) => (
          <div key={i} className="flex items-center gap-2.5 px-8 text-sm font-semibold whitespace-nowrap">
            <it.icon size={16} className="text-[#62B848]" />
            {it.text}
          </div>
        ))}
      </div>
    </div>
  );
}
